import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  // Base64-decoded AES-256 secret key
  private secretKey = CryptoJS.enc.Base64.parse('o0JYcg76u+CmPy7vZ3w594eR7DmmnpnN3wc3Qr/VAUo=');

  // Encrypt data function
  encryptData(data: any): string {
    // Ensure the data is a string (if not, convert it to stringified JSON)
    const stringData = typeof data === 'string' ? data : JSON.stringify(data);

    // Generate a random 16-byte IV
    const iv = CryptoJS.lib.WordArray.random(16);

    // Encrypt the data using AES-256-CBC
    const encrypted = CryptoJS.AES.encrypt(stringData, this.secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Convert IV and ciphertext to Base64 strings
    const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
    const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

    // Combine IV and encrypted data with a delimiter (e.g., '|')
    const combinedData = ivBase64 + '|' + encryptedBase64;
    

    // Return the combined data as a single string
    return combinedData;
  }

  decryptData(encryptedData: string): string {
    try {
      // Split the encrypted data into IV and ciphertext
      const [ivBase64, encryptedBase64] = encryptedData.split('|');
  
      if (!ivBase64 || !encryptedBase64) {
        throw new Error('Invalid data format. IV or encrypted data is missing.');
      }
  
      // Decode Base64 to WordArray
      const iv = CryptoJS.enc.Base64.parse(ivBase64);
      const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64);
  
      // Decrypt the message using CryptoJS
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        this.secretKey,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      );
  
      //console.log('Decrypted Object:', decrypted);
  
      // Convert the decrypted data to UTF-8 string
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  
      //console.log('Decrypted Text:', decryptedText);
  
      // Check if the decrypted data is valid UTF-8
      if (decryptedText) {
        return decryptedText;
      } else {
        console.warn('Decrypted data is not valid UTF-8 text.');
        return 'Decrypted data is not valid UTF-8';
      }
    } catch (error) {
      console.error('Decryption error:', error);
      return 'Decryption failed';
    }
  }
  
}
